import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    importType: String,
    month: String,
    year: String,
    url: String
  }

  connect() {
    this.poll()
  }

  disconnect() {
    this.stopPolling()
  }

  poll() {
    this.pollInterval = setInterval(() => {
      this.fetchUpdate()
    }, 2000) // Poll every 2 seconds
  }

  stopPolling() {
    if (this.pollInterval) {
      clearInterval(this.pollInterval)
    }
  }

  async fetchUpdate() {
    const params = new URLSearchParams({
      import_type: this.importTypeValue,
      month: this.monthValue,
      year: this.yearValue
    })

    try {
      const response = await fetch(`${this.urlValue}?${params}`, {
        headers: {
          "Accept": "text/vnd.turbo-stream.html"
        }
      })

      if (response.ok) {
        const html = await response.text()
        
        // Check if the response indicates job is complete (doesn't contain the polling controller)
        if (!html.includes('data-controller="salary-import-poll"')) {
          this.stopPolling()
        }
        
        Turbo.renderStreamMessage(html)
      }
    } catch (error) {
      console.error("Polling error:", error)
      this.stopPolling()
    }
  }
}

